import template from './email-verification-confirm.tpl.pug';

export default {
    selector: 'dbAEmailVerificationConfirm',
    template: template(),
};



// WEBPACK FOOTER //
// ./src/application/scene/identity/scene/email-verification/scene/email-verification-confirm/email-verification-confirm.cmpt.js